import { getPrePackSize } from "@faire/retailer-visitor-shared/features/PrePacks/getPrePackSize";
import { isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { getProductOptionProperty } from "@faire/retailer-visitor-shared/lib/product";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
export var buildCaseQuantityText = function(product, selectedOption, strictLocalize) {
    if (selectedOption && isPrePackProductOption(selectedOption)) {
        var prePackUnitCount = getPrePackSize(selectedOption.sizing_quantity);
        if (prePackUnitCount > 0) {
            return strictLocalize({
                id: "JbuN9R",
                defaultMessage: [
                    {
                        type: 1,
                        value: "prePackUnitCount"
                    },
                    {
                        type: 0,
                        value: " per prepack"
                    }
                ]
            }, DEPRECATED_backwardsCompatibleValues({
                prePackUnitCount: prePackUnitCount
            }));
        } else {
            return strictLocalize({
                id: "8YCg09",
                defaultMessage: [
                    {
                        type: 0,
                        value: "(Unavailable)"
                    }
                ]
            });
        }
    }
    if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.state) !== IProduct.State.FOR_SALE) {
        return strictLocalize({
            id: "8YCg09",
            defaultMessage: [
                {
                    type: 0,
                    value: "(Unavailable)"
                }
            ]
        });
    }
    if (product.per_style_min_order_quantity) {
        return strictLocalize({
            id: "pK3q1g",
            defaultMessage: [
                {
                    type: 0,
                    value: "Min Qty "
                },
                {
                    type: 1,
                    value: "quantity"
                }
            ]
        }, DEPRECATED_backwardsCompatibleValues({
            quantity: product.per_style_min_order_quantity
        }));
    }
    return strictLocalize({
        id: "NWtTov",
        defaultMessage: [
            {
                type: 0,
                value: "Case of "
            },
            {
                type: 1,
                value: "numCase"
            }
        ]
    }, DEPRECATED_backwardsCompatibleValues({
        numCase: getProductOptionProperty(product, "unit_multiplier") || 1
    }));
};
